import { apiClient } from "@/lib/apiClient";
import type { ApprovalStatus } from "@/types/domain";

export interface SymphonyPushRequest {
  values: Record<string, unknown>;
}

export interface SymphonyPushResponse {
  documentId: string;
  parcelNumber: number;
  approvalStatus: ApprovalStatus;
  approvedBy: string | null;
  symphonyResponse: Record<string, unknown>;
}

export function pushToSymphony(
  documentId: string,
  body: SymphonyPushRequest,
): Promise<SymphonyPushResponse> {
  return apiClient.post<SymphonyPushResponse>(
    `/api/documents/${encodeURIComponent(documentId)}/symphony-push`,
    body,
  );
}
